export enum TextStyle {
    confirmation = 'th-text-confirmation',
    alert = 'th-text-alert',
    default = ''
}